export default "__VITE_ASSET__ba72a394__"